import { forwardRef } from "react"
import { classes } from "utils"

export const Layout = forwardRef(
  ({ className, vertical, children, as: Component = "div", ...props }, ref) => (
    <Component
      className={classes("layout", className)}
      css={{
        display: "flex",
        flexDirection: vertical ? "column" : "row",
        alignItems: vertical ? "flex-start" : "center",
      }}
      ref={ref}
      {...props}
    >
      {children}
    </Component>
  ),
)

Layout.displayName = "Layout"
